import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityBank } from "../../entity/EntityBank";

export class DtoBanksPostReq extends EntityBank {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
